import { inject, Injectable } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { SbDialogService } from '@sb/ui/dialog';
import { ModalBundle } from '@shiftbase-com/ts-shared/models';

import { TargetSettingDialogComponent } from '../target-setting/target-setting-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TargetSettingOnboardingService {
  private dialogService = inject(SbDialogService);

  openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open<TargetSettingDialogComponent, ModalBundle, OnboardingDialogResult>(TargetSettingDialogComponent, {
        data: { originator },
      });
  }
}
